import {ENVIRONMENT_DEVARANA, UI_ID_PANEL10_RESTYPE, UI_ID_PANEL14_RESSUBTYPE, UI_ID_PANEL17_PEOPLE, UI_ID_PANEL20_CALENDAR, UI_ID_PANEL30_TIME, UI_ID_PANEL40_PACKAGEDEAL, UI_ID_PANEL50_TREATMENTS, UI_ID_PANEL60_FORM, UI_ID_PANEL70_PAY} from "../../AppConstants";

// dit is wat er altijd in de broncode van de reserveerpagina stond - geen reactivity dus niet gewrapped in $state

export let page_json = {
  data: null
};

export let progress_form_booking = {
  form: false
};

export let progress_form_login = {
  form: false
};

export let progress_form_payment = {
  form: false
};

export const progress = $state({
  bIsLocal: false, // hier op false laten staan.. wordt vanzelf gedetecteerd
  bWasReceiptLarge: false,
  sNextButtonState: 'hidden',
  bIsBookingTypeChosen: false,
  bIsRestaurantTunerOpen: false,
  oTimeSlotPopup: {
    bIsOpen: false,
    iProductID: false,
    oPerson: false,
    aAvailableSlots: false
  },
  sCalendarInfo: false,
  bShowServiceMessage: false,
  sServiceMessageColor: false,
  sServiceMessageContent: false,
  iSubmitToServerCounter: 1,
  bWasSubmittedToServer: false,
  bWasRedirectedToPaymentProviderBeforeNow: false,
  bThereWasAPreselectedPackageDealButItIsNotAvailable: false,
  bThereWasAPreselectedTreatmentButItIsNotAvailable: false,
  bShowMessageThereWasAPreselectedTreatmentButItIsNotAvailable: false,
  sServerFeedbackAfterSubmission: false,
  bShowNoticeInRightPanel: false,
  bIsDialogOpen: false,
  bIsReceiptReadyToBeVisible: false,
  bIsReceiptInEditMode: false,
  sDialogTitle: '',
  sDialogContent: '',
  bIsReceiptDialogOpen: false,
  //sLastActiveProductCatTab: false,
  bIsProductDialogOpen: false,
  iProductDialogProductID: 0,
  bIsPackageDealDialogOpen: false,
  iPackageDialogPackageDealID: 0,
  bWasJSONDataFromPageReceived: false,
  bWasJSONDataFromPageParsed: false,
  bWasWidgetsSharedBootSequenceStarted: false,
  bWasBaseJSONForWidgetsReceived: false,
  bWasBaseJSONForWidgetsParsed: false,
  aCalendarDates: [],
  oValidationReport: {
    aAllowedSteps: [10],
    aIncorrectFields: {
      [UI_ID_PANEL10_RESTYPE]: [],
      [UI_ID_PANEL14_RESSUBTYPE]: [],
      [UI_ID_PANEL17_PEOPLE]: [],
      [UI_ID_PANEL20_CALENDAR]: [],
      [UI_ID_PANEL30_TIME]: [],
      [UI_ID_PANEL40_PACKAGEDEAL]: [],
      [UI_ID_PANEL50_TREATMENTS]: [],
      [UI_ID_PANEL60_FORM]: [],
      [UI_ID_PANEL70_PAY]: []
    }
  },
  sEnvironmentID: 'ENVIRONMENT_DEVARANA',
  bIsEnvDevarana: true,
  bIsEnvDenIlp: false,
  bIsEnvRidderrode: false,
  bIsEnvSweetLake: false,
  dog: null,

  sImageURLMain: '',
  sImageURLProduct: '',
  sImageURLPackageDeal: '',

  sFetchCustomerAPIEndpoint: '', // nog gebruikt?
  sURLPassword: '',
  sURLPrivacy: '',
  sURLHouseholdRules: '',
  sURLInsurance: '',
  bHideNextButton: false,
  bIsLoginScreenActive: false,
  bIsDebugModeEnabled: false,
  bIsFetchingDog: false,
  bIsFetchingTreatments: false,
  bIsFetchingPackageDeals: false,
  bIsFetchingLogin: false,
  bIsFetchingCalendar: false,
  bIsFetchingRestaurant: false,
  // bIsFetchingGiftcard: false,
  sFetchingLoginError: false,
  bIsFetchingReservationFeedback: false,
  sFetchingError: false,
  aSteps: [10, 14, 17, 20, 30, 40, 50, 60, 70, 80],
  iHighestShownStep: 10,
  iHighestAttemptedStep: 10, // nodig om bij te houden voor welke stappen we validaties willen zien.. pas als iemand door heeft geprobeerd te klikken naar 20 tonen we feedback voor < 20
  iCurrentVisibleStep: 10, // omdat het mogelijk is dat je qua data invullen al een paar stappen verder bent, maar terug gaat naar een andere stap
  iLoginScreenComponentRefreshCounter: 0,
  iFormComponentRefreshCounter: 0,
  bIsFetchingGiftCardValue: false,
  bIsFetchingBadenkaartValue: false,
  iLastSubmittedTimestamp: 0,
  iLastSubmittedBookingUpdateCounter: 0
});

window.hmk_progress = () => {
  console.log($state.snapshot(progress));
}

window.hmk_page_JSON = () => {
  console.log(page_json);
}
